<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full" id="sample-order-invoice-list">
                <vx-card v-if="dataLoaded" class="mt-8" title="Invoices">
                    <h4 v-if="account_type == 'proforma'" class="mb-8 uppercase text-danger text-center">
                        {{ account_type }} Account
                    </h4>
                    <template slot="actions">
                        <vs-button v-can="'create-edit-invoice'" @click="onClickCreateInvoice()" icon-pack="feather"
                            icon="icon-plus" class="mr-4 mt-4 mb-4 ml-auto" color="primary" type="filled"
                            size="small">Create</vs-button>
                    </template>

                    <vs-table noDataText="No invoices available" stripe :data="invoice_list">

                        <template slot="thead">
                            <vs-th>INV NUMBER</vs-th>
                            <vs-th>INV DATE</vs-th>
                            <vs-th>INV AMOUNT (Incl VAT) in GBP</vs-th>
                            <vs-th v-if="!__isCurrencyGbp(account_currency)">INV AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                            <vs-th>INV STATUS</vs-th>
                            <vs-th>Last Invoice Sent Date</vs-th>
                            <vs-th>ACTION</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].number">
                                    {{ data[indextr].number }}
                                </vs-td>

                                <vs-td :data="data[indextr].date">
                                    {{ data[indextr].date }}
                                </vs-td>

                                <vs-td>
                                    {{ calculateTotalInvoiceAmount(data[indextr].items, data[indextr].add_cost, 1) }}
                                </vs-td>

                                <vs-td v-if="!__isCurrencyGbp(account_currency)">
                                    {{ calculateTotalInvoiceAmount(data[indextr].items, data[indextr].add_cost, fx_value) }}
                                </vs-td>

                                <vs-td :data="data[indextr].status.name">
                                    <vs-chip style="border-radius: 0" class="text-center text-xs" transparent
                                        :color="invoiceStatusColorFactory(data[indextr].status.name)">
                                        {{ data[indextr].status.name }}
                                    </vs-chip>
                                </vs-td>

                                <vs-td>
                                    {{ data[indextr].last_email_sent_at != "" ?
                    convertDate(data[indextr].last_email_sent_at) : 'N/A' }}
                                </vs-td>

                                <vs-td :data="data[indextr].amount">
                                    <div class="vx-row">
                                        <vx-tooltip class="ml-2" text="View invoice" position="top">
                                            <vs-button
                                                @click.stop="onClickInvoiceViewTest(data[indextr].id, data[indextr].status.name, false, data[indextr].invoice_secret_code, !!data[indextr].last_email_sent_at, data[indextr].customer_id || customer_id, data[indextr].customer_lead || customer_lead)"
                                                size="small" color="primary" type="border" icon-pack="feather"
                                                icon="icon-file"></vs-button>
                                        </vx-tooltip>
                                        <vx-tooltip
                                            v-if="['In-Draft', 'In Draft'].includes(data[indextr].status.name)" class="ml-2"
                                            text="Update invoice" position="top">
                                            <vs-button @click.stop="onClickUpdateInvoice(data[indextr])" size="small"
                                                color="warning" type="border" icon-pack="feather"
                                                icon="icon-edit"></vs-button>
                                        </vx-tooltip>

                                        <vx-tooltip
                                            v-if="(['Sent', 'Overdue'].includes(data[indextr].status.name) || account_type == 'proforma') && data[indextr].status.name !== 'Paid'"
                                            class="ml-2" text="Status change to inv paid" position="top">
                                            <vs-button
                                                @click.stop="onClickConfirmStatusChange(data[indextr].id, 'paid')"
                                                size="small" color="success" type="filled" icon-pack="feather"
                                                icon="icon-check"></vs-button>
                                        </vx-tooltip>
                                        <vx-tooltip
                                            v-if="['In Draft', 'Overdue', 'Sent', 'In-Draft'].includes(data[indextr].status.name)"
                                            class="ml-2" text="Status change to inv cancel" position="top">
                                            <vs-button
                                                @click.stop="onClickConfirmStatusChange(data[indextr].id, 'cancel')"
                                                size="small" color="danger" type="filled" icon-pack="feather"
                                                icon="icon-x"></vs-button>
                                        </vx-tooltip>
                                        <!-- <vx-tooltip v-if="data[indextr].last_email_sent_at !== ''" class="ml-2"
                                            text="Email log" position="top">
                                            <vs-button @click.stop="onClickViewEmailLog(data[indextr].id)" size="small"
                                                color="danger" type="border" icon-pack="feather"
                                                icon="icon-mail"></vs-button>
                                        </vx-tooltip> -->

                                    </div>
                                </vs-td>
                                <template class="expand-user" slot="expand">
                                    <div class="con-expand-users w-4/5">
                                        <vs-table :data="data[indextr].items">

                                            <template slot="header">
                                                <h5 class="mb-4">Invoice items</h5>
                                            </template>

                                            <template slot="thead">
                                                <vs-th>ITS PRODUCT CODE</vs-th>
                                                <vs-th>ITS PRODUCT NAME</vs-th>
                                                <vs-th>NOMINAL CODE</vs-th>
                                                <vs-th>QUANTITY (GRAM)</vs-th>
                                                <vs-th>UNIT PRICE ({{ account_currency }}/KG)</vs-th>
                                                <vs-th>AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                                                <vs-th>AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                                            </template>

                                            <template slot-scope="{data}">
                                                <vs-tr :key="index_inv" v-for="(tr_inv, index_inv) in data">

                                                    <vs-td :data="tr_inv.formulation_code">
                                                        {{ tr_inv.formulation_code }}
                                                    </vs-td>

                                                    <vs-td :data="tr_inv.formulation_name">
                                                        {{ tr_inv.formulation_name }}
                                                    </vs-td>

                                                    <vs-td>
                                                        {{ tr_inv.sage_nominal_code ? tr_inv.sage_nominal_code.code :
                    'N/A' }}
                                                    </vs-td>

                                                    <vs-td :data="tr_inv.quantity">
                                                        {{ tr_inv.quantity }}
                                                    </vs-td>

                                                    <vs-td :data="tr_inv.price">
                                                        {{ tr_inv.price | format_price(fx_value) }}
                                                    </vs-td>

                                                    <vs-td :data="tr_inv.amount_ex_vat">
                                                        {{ calculateItemAmountExVat(tr_inv, fx_value) }}
                                                    </vs-td>

                                                    <vs-td :data="tr_inv.amount_in_vat">
                                                        {{ calculateItemAmountInVat(tr_inv, fx_value) }}
                                                    </vs-td>

                                                </vs-tr>
                                            </template>

                                        </vs-table>

                                        <vs-table class="mt-8" :data="data[indextr].add_cost">

                                            <template slot="header">
                                                <h5 class="mb-4">Additional cost</h5>
                                            </template>

                                            <template slot="thead">
                                                <vs-th>NAME</vs-th>
                                                <vs-th>AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                                                <vs-th>AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                                            </template>

                                            <template slot-scope="{data}">
                                                <vs-tr :key="index_cost" v-for="(tr_cost, index_cost) in data">

                                                    <vs-td :data="tr_cost.name">
                                                        {{ tr_cost.name }}
                                                    </vs-td>

                                                    <vs-td :data="tr_cost.amount_ex_vat">
                                                        {{ calculateCostAmountExVat(tr_cost, fx_value) }}
                                                    </vs-td>

                                                    <vs-td :data="tr_cost.amount_in_vat">
                                                        {{ calculateCostAmountInVat(tr_cost, fx_value) }}
                                                    </vs-td>

                                                </vs-tr>
                                            </template>

                                        </vs-table>
                                        <div class="vx-row mt-8">
                                            <div class="vx-col w-full">
                                                <h5>Notes</h5>
                                                {{ tr.note || 'N/A' }}
                                            </div>
                                        </div>
                                        <div class="vx-row mt-8 text-primary">
                                            <div class="vx-col w-1/2 float-right font-bold">
                                                Total invoice value ({{ account_currency }}) :
                                                {{ calculateTotalInvoiceAmount(data[indextr].items,
                                                data[indextr].add_cost, fx_value) }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </vs-tr>
                        </template>

                    </vs-table>
                </vx-card>
            </div>
        </div>
        <SampleOrderInvoicePdfPopUp ref="sampleOrderInvoicePdfPopUp" />
        <SampleOrderInvoice ref="sampleOrderInvoice" @refreshData="refreshData" />
        <CreateSampleOrderInvoicePopUp ref="createSampleOrderInvoicePopUp" />
        <UpdateSampleOrderInvoicePopUp ref="updateSampleOrderInvoicePopUp" @refreshData="refreshData" />
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')
import SampleOrderInvoicePdfPopUp from '@/components/popups/customer/sample-orders/invoices/SampleOrderInvoicePdfPopUp.vue'
import SampleOrderInvoice from '@/components/popups/pdf/SampleOrderInvoice.vue'
import CreateSampleOrderInvoicePopUp from '@/components/popups/customer/sample-orders/invoices/CreateSampleOrderInvoicePopUp.vue'
import UpdateSampleOrderInvoicePopUp from '@/components/popups/customer/sample-orders/invoices/UpdateSampleOrderInvoicePopUp.vue'
import moment from "moment/moment";
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Calculations from '@/mixins/Calculations'

export default {
    name: 'SampleOrderInvoiceList',
    data() {
        return {
            id: null,
            dataLoaded: false,
        }
    },
    mixins: [SuccessMessage, ErrorMessages, Calculations],
    props: {
        order_code: {
            type: String,
            default: ''
        },
        account_type: {
            type: String,
            default: ''
        },
        account_currency: {
            type: String,
            default: 'GBP'
        },
        customer_id: {
            default: null
        },
        customer_lead: {
            default: null
        },
        fx_value: {
            default: 1
        },
        dataLoaded: {
            type: Boolean,
            default: false
        },
        invoice_list: {
            type: Array,
            default: () => []
        }
    },
    components: {
        SampleOrderInvoicePdfPopUp,
        SampleOrderInvoice,
        CreateSampleOrderInvoicePopUp,
        UpdateSampleOrderInvoicePopUp
    },
    mounted() {
        this.id = this.$route.params.id
    },
    methods: {
        async refreshData() {
           await this.$emit('refreshData')
        },
        calculateItemAmountExVat(item, fx_rate = 1) {
            const unitPrice = Number(this.$options.filters.format_price(item.price, fx_rate))
            const qtyInKg = Number(item.quantity) / 1000
            return (qtyInKg * unitPrice).toFixed(2)
        },
        calculateItemAmountInVat(item, fx_rate = 1) {
            const amountExVat = Number(this.calculateItemAmountExVat(item, fx_rate))
            const taxRate = Number(item.tax_percent || 0) / 100
            return (amountExVat * (1 + taxRate)).toFixed(2)
        },
        calculateCostAmountExVat(cost, fx_rate = 1) {
            return Number(this.$options.filters.format_price(cost.amount_ex_vat || cost.amount, fx_rate)).toFixed(2)
        },
        calculateCostAmountInVat(cost, fx_rate = 1) {
            const ex = Number(this.calculateCostAmountExVat(cost, fx_rate))
            const vatPercent = Number(cost.vat_percent || 0) / 100
            return (ex * (1 + vatPercent)).toFixed(2)
        },
        calculateTotalInvoiceAmount(inv_items = [], add_cost = [], fx_rate = 1) {
            const total_inv = (inv_items || []).reduce((a, b) => a + Number(this.calculateItemAmountInVat(b, fx_rate)), 0)
            const total_add_cost = (add_cost || []).reduce((a, b) => a + Number(this.calculateCostAmountInVat(b, fx_rate)), 0)
            return Number(total_inv + total_add_cost).toFixed(2)
        },
        invoiceStatusColorFactory(status) {
            switch (status) {
                case 'Pending':
                    return 'warning'
                case 'Paid':
                    return 'primary'
                case 'Refunded':
                    return 'warning'
                case 'Cancelled':
                    return 'danger'
            }
        },
        convertDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        async onClickInvoiceViewTest(id, status_name, is_performa, secret_code, is_sent, customer_id, customer_lead = null) {
            await this.$refs.sampleOrderInvoice.openPopup(id, this.order_code, status_name, is_sent, customer_id || this.customer_id, customer_lead || this.customer_lead)
        },
        async onClickCreateInvoice() {
            await this.$refs.createSampleOrderInvoicePopUp.openPopup(this.id, this.account_currency, this.fx_value)
        },
        async onClickUpdateInvoice(data) {
            await this.$refs.updateSampleOrderInvoicePopUp.openPopup(data.id, data.sample_order_id || this.id, this.account_currency, this.fx_value)
        },
        async onClickConfirmStatusChange(id, status) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Confirm`,
                text: 'Are you sure you want to change the status ?',
                accept: this.onClickUpdateInvoiceStatus,
                parameters: [id, status]
            })
        },
        async onClickUpdateInvoiceStatus(params) {
            await this.$vs.loading({
                container: '#sample-order-invoice-list',
                scale: 0.45
            })
            try {
                await CustomerRepository.sampleInvoiceStatusChange(params[0], params[1])
                this.showSuccessMessage('Invoice status changed successfully!')
                await this.$emit('refreshData')
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#sample-order-invoice-list > .con-vs-loading')
        },
    }

}
</script>
<style lang="">

</style>